module.exports = __webpack_public_path__ + "assets/img/head3-zh.f2c5083e.png";